const RedeemApp = () => {
  // this is temp to test the route / controller logic
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '50vh',
        width: '100%',
      }}
    >
      <h1>This is where the redeem page would be</h1>
    </div>
  );
};

export default RedeemApp;
